'use client';

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

const galleryItems = [
{
  id: 'g1',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_170bb0eda-1772185877776.png",
  alt: 'Profesjonalne polerowanie lakieru samochodu — usuwanie rys i przywracanie głębokiego połysku',
  label: 'Korekta Lakieru',
  span: 'md:col-span-2 md:row-span-2'
},
{
  id: 'g2',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_19b5c6f17-1772185875184.png",
  alt: 'Mycie ciśnieniowe karoserii samochodu — usuwanie brudu i zanieczyszczeń przed detalingiem',
  label: 'Mycie Zewnętrzne',
  span: ''
},
{
  id: 'g3',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_176143963-1772185871502.png",
  alt: 'Pranie tapicerki samochodowej — czyszczenie foteli i dywanów ekstrakcją parową',
  label: 'Pranie Tapicerki',
  span: ''
},
{
  id: 'g4',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_17b61e24e-1772185880468.png",
  alt: 'Nakładanie powłoki ochronnej na lakier samochodu — zabezpieczenie przed zarysowaniami i UV',
  label: 'Ochrona Lakieru',
  span: ''
},
{
  id: 'g5',
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_13d2c6547-1772185873630.png",
  alt: 'Czyszczenie wnętrza samochodu — odkurzanie i pielęgnacja deski rozdzielczej oraz konsoli',
  label: 'Detailing Wnętrza',
  span: ''
}];


export default function GallerySection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('is-visible');
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef?.current?.querySelectorAll('.reveal-hidden, .reveal-scale');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="galeria" className="py-24 md:py-32 bg-kd-dark">
      <div className="max-w-container mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 reveal-hidden">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-12 bg-kd-cyan" />
              <span className="text-kd-cyan text-xs font-body font-semibold uppercase tracking-widest">
                Nasze Realizacje
              </span>
            </div>
            <h2 className="font-heading font-black uppercase text-white" style={{ fontSize: 'clamp(2.5rem, 6vw, 5.5rem)', lineHeight: '0.95' }}>
              EFEKTY<br />
              <span className="gradient-text">MÓWIĄ SAME</span>
            </h2>
          </div>
          <p className="text-kd-muted font-body max-w-sm leading-relaxed">
            Każde auto to osobny projekt. Poniżej kilka efektów naszej pracy — od korekty lakieru po pranie tapicerki.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 auto-rows-[220px]">
          {galleryItems?.map((item, i) =>
          <div
            key={item?.id}
            className={`${item?.span} relative rounded-2xl overflow-hidden group reveal-scale`}
            style={{ transitionDelay: `${i * 0.1}s` }}>
            
              <AppImage
              src={item?.src}
              alt={item?.alt}
              fill
              className="object-cover transition-transform duration-700 group-hover:scale-105" />
            
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-kd-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
              {/* Label */}
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-400">
                <span className="font-heading font-bold text-white text-lg uppercase tracking-wide">
                  {item?.label}
                </span>
              </div>
              {/* Cyan border on hover */}
              <div className="absolute inset-0 rounded-2xl border border-transparent group-hover:border-kd-cyan/30 transition-colors duration-300 pointer-events-none" />
            </div>
          )}
        </div>

        {/* CTA below */}
        <div className="text-center mt-12 reveal-hidden">
          <p className="text-kd-muted font-body mb-5">
            Chcesz zobaczyć więcej? Odwiedź nas na Facebook lub zadzwoń po wycenę.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://www.facebook.com/pranietapicerkisiepraw/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-heading font-bold text-white uppercase tracking-wider text-base">
              
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
              Facebook
            </a>
            <a
              href="tel:+48731655388"
              className="btn-primary relative inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-heading font-bold text-white uppercase tracking-wider text-base z-10">
              
              Umów Termin
            </a>
          </div>
        </div>
      </div>
    </section>);

}